export function generateMaskedCcNumber(prefix: string, postfix: string, length: number) {
  const numXs = Math.max(0, length - (prefix.length + postfix.length));

  return prefix + 'x'.repeat(numXs) + postfix;
}
